import * as apps from '../enums/apps';
import * as ToggleReadAPIs from './toggleRead';

export const markItemRead = ({ source, id }) => {
    const markAsReadCallback = isNotification(source)
        ? ToggleReadAPIs.markNotificationRead
        : ToggleReadAPIs.markConversationRead;

    return markAsReadCallback(id);
};

export const markItemUnread = ({ source, id }) => {
    const markAsUnreadCallback = isNotification(source)
        ? ToggleReadAPIs.markNotificationUnread
        : ToggleReadAPIs.markConversationUnread;

    return markAsUnreadCallback(id);
};

const isNotification = (source) => source === apps.APP_NAME_NOTIFICATIONS;
